export default __webpack_public_path__ + "static/media/0_lower_right.ee08c17d.svg";